<template>
  <div class="person-container">
    <!-- 用户信息卡片 -->
    <div class="user-card">
      <div class="avatar" @click="showLogoutModal = true">
        <span class="avatar-icon">♻️</span>
        <span class="avatar-text">权益go</span>
      </div>
      <div class="user-info">
        <h2 class="username">{{ userInfo.name }}</h2>
        <div class="user-details">
          <span class="detail-item">状态：{{ userInfo.state }}</span>
          <span class="detail-item">订购：{{ userInfo.balance }}</span>
          <span class="detail-item">截止：{{ userInfo.frozenAmount }}</span>
        </div>
      </div>
      <div class="balance-section">
        <button class="detail-btn" @click="showDetailModalHandler">
          📋 领取记录
        </button>
      </div>
    </div>

    <!-- 公告轮播 -->
    <div class="notice-section">
      <div class="notice-icon">📢</div>
      <div class="notice-content">
        <div class="notice-track" :style="noticeTrackStyle">
          <div v-for="(notice, index) in notices" :key="notice.id" class="notice-item">
            {{ notice.content }}
          </div>
        </div>
      </div>
      <div class="notice-dots">
        <span v-for="(notice, index) in notices" :key="notice.id" class="dot"
              :class="{ active: index === currentNoticeIndex }" @click="goToNotice(index)"></span>
      </div>
    </div>

    <!-- 任务领取 -->
    <div class="task-section">
      <div class="section-header">
        <h3>🎯 会员权益领取</h3>
      </div>

      <!-- Tab选项 (只保留待领取) -->
      <div class="tab-container">
        <button class="tab-btn" :class="{ active: activeTab === 'pending' }" @click="activeTab = 'pending'">
          会员权益领取
          <span class="tab-count">{{ cards.pending.length }}</span>
        </button>
      </div>

      <!-- 待领取卡片 -->
      <div v-if="activeTab === 'pending'" class="pending-cards">
        <div v-for="card in cards.pending" :key="card.id" class="pending-card">
          <div class="card-info">
            <img v-if="card.cardLogo" :src="card.cardLogo" alt="卡片logo" class="card-logo" />
            <div class="card-icon" v-else>🎴</div>
            <div class="card-details">
              <div class="card-name">{{ card.name }}</div>
              <div class="card-value">{{ card.proTsy }}</div>
            </div>
          </div>
          <button class="claim-btn" @click="claimCard(card)" :disabled="thisljlqShow || isClaiming">
            立即领取
          </button>
        </div>
      </div>
    </div>

    <!-- 领取确认弹框 -->
    <div v-if="showClaimModal" class="modal-overlay" @click.self="showClaimModal = false">
      <div class="modal-content">
        <div class="modal-header">
          <h3>🎁 确认领取</h3>
          <button class="close-btn" @click="showClaimModal = false">✕</button>
        </div>
        <div class="modal-body">
          <div v-if="currentCard" class="claim-info">
            <div class="claim-item">
              <span class="claim-label">权益名称：</span>
              <span class="claim-value highlight">{{ currentCard.name }}</span>
            </div>
            <div class="claim-item">
              <span class="claim-value">{{ currentCard.proSm }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-btn" @click="showClaimModal = false">取消</button>
          <button class="confirm-btn" @click="confirmClaim" :disabled="isClaiming">
            {{ isClaiming ? '领取中...' : '确认领取' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 领取结果弹框（成功） -->
    <div v-if="showClaimResultModal" class="modal-overlay" @click.self="closeClaimResultModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>✅ 领取成功</h3>
          <button class="close-btn" @click="closeClaimResultModal">✕</button>
        </div>
        <div class="modal-body">
          <div v-if="currentCard" class="process-info">
            <div class="process-item">
              <span class="process-label">权益名称：</span>
              <span class="process-value">{{ currentCard.name }}</span>
            </div>
            <div class="process-item">
              <span class="process-label">领取状态：</span>
              <span class="process-value highlight">领取成功</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="confirm-btn" @click="closeClaimResultModal">确定</button>
        </div>
      </div>
    </div>

    <!-- 处理卡片弹框（保留但未使用） -->
    <div v-if="showProcessModal" class="modal-overlay" @click.self="showProcessModal = false">
      <div class="modal-content">
        <div class="modal-header">
          <h3>📋 处理卡片</h3>
          <button class="close-btn" @click="showProcessModal = false">✕</button>
        </div>
        <div class="modal-body">
          <div v-if="currentProcessCard" class="process-info">
            <div class="process-item">
              <span class="process-label">卡名：</span>
              <span class="process-value">{{ currentProcessCard.name }}</span>
            </div>
            <div class="process-item">
              <span class="process-label">面值：</span>
              <span class="process-value highlight">{{ currentProcessCard.value }}</span>
            </div>
            <div class="process-item">
              <span class="process-label">回收价：</span>
              <span class="process-value highlight">{{ currentProcessCard.recyclePrice }}</span>
            </div>
            <div class="process-item">
              <span class="process-label">领取时间：</span>
              <span class="process-value">{{ currentProcessCard.claimedAt }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="process-fail-btn" @click="processFail">处理失败</button>
          <button class="process-success-btn" @click="processSuccess">处理成功</button>
        </div>
      </div>
    </div>

    <!-- 处理结果弹框（保留但未使用） -->
    <div v-if="showResultModal" class="modal-overlay" @click.self="closeResultModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ processResult === 'success' ? '✅ 处理成功' : '❌ 处理失败' }}</h3>
          <button class="close-btn" @click="closeResultModal">✕</button>
        </div>
        <div class="modal-body">
          <div v-if="currentProcessCard" class="process-info">
            <div class="process-item">
              <span class="process-label">卡名：</span>
              <span class="process-value">{{ currentProcessCard.name }}</span>
            </div>
            <div class="process-item">
              <span class="process-label">面值：</span>
              <span class="process-value highlight">{{ currentProcessCard.value }}</span>
            </div>
            <div class="process-item">
              <span class="process-label">回收价：</span>
              <span class="process-value highlight">{{ currentProcessCard.recyclePrice }}</span>
            </div>
            <div class="process-item">
              <span class="process-label">处理状态：</span>
              <span class="process-value">{{ processResult === 'success' ? '处理成功' : '处理失败' }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="confirm-btn" @click="closeResultModal">确定</button>
        </div>
      </div>
    </div>

    <!-- 领取记录弹框（动态数据） -->
    <div v-if="showDetailModal" class="modal-overlay" @click.self="showDetailModal = false">
      <div class="modal-content">
        <div class="modal-header">
          <h3>📋 领取记录</h3>
          <button class="close-btn" @click="showDetailModal = false">✕</button>
        </div>
        <div class="modal-body">
          <div v-if="claimRecordsLoading" class="loading-tip">加载中...</div>
          <div v-else-if="claimRecords.length === 0" class="empty-state">
            <p>暂无领取记录</p>
          </div>
          <table v-else class="transaction-table">
            <thead>
            <tr>
              <th>领取时间</th>
              <th>&nbsp;&nbsp;&nbsp;&nbsp;权益名称</th>
              <th>状态</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, idx) in claimRecords" :key="idx">
              <td>{{ item.time }}</td>
              <td>{{ item.proName }}</td>
              <td class="status-success">{{ item.lqState}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button class="confirm-btn" @click="showDetailModal = false">关闭</button>
        </div>
      </div>
    </div>

    <!-- 退出登录确认弹框 -->
    <div v-if="showLogoutModal" class="modal-overlay" @click.self="showLogoutModal = false">
      <div class="modal-content">
        <div class="modal-header">
          <h3>⚠️ 确认退出</h3>
          <button class="close-btn" @click="showLogoutModal = false">✕</button>
        </div>
        <div class="modal-body">
          <p style="text-align: center; color: #666; margin: 0;">确定要退出登录吗？</p>
        </div>
        <div class="modal-footer">
          <button class="cancel-btn" @click="showLogoutModal = false">取消</button>
          <button class="confirm-btn" @click="confirmLogout">确认退出</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'person',
  data() {
    return {
      userInfo: {
        state: 0,
        name: '',
        phone: '',
        balance: 128.00
      },
      showDetailModal: false,
      showClaimModal: false,
      showProcessModal: false,
      showResultModal: false,
      showClaimResultModal: false,
      showLogoutModal: false,
      currentCard: null,
      currentProcessCard: null,
      processResult: null,
      isClaiming: false,
      isProcessing: false,
      thisljlqShow: true,
      claimRecords: [],
      claimRecordsLoading: false,
      transactions: [],
      currentNoticeIndex: 0,
      currentTime: '',
      notices: [
        { id: 1, content: '🎉  精心挑选多款热门会员权益！' },
        { id: 2, content: '🔥  内容类型丰富、题材新颖' },
        { id: 3, content: '🎁 关注“河马权益G0”服务号，领取会员权益' }
      ],
      activeTab: 'pending',
      cards: {
        pending: [],
        claimed: [],
        processed: []
      },
    }
  },
  computed: {
    noticeTrackStyle() {
      return {
        transform: `translateX(-${this.currentNoticeIndex * 100}%)`
      }
    }
  },
  mounted() {
    // 设置浏览器页面标题
    document.title = '河马剧场热门权益'
    this.checkLoginTimeout()
    this.loginTimeoutTimer = setInterval(() => {
      this.checkLoginTimeout()
    }, 60000)
    this.startAutoPlay()
    this.updateCurrentTime()
    setInterval(() => {
      this.updateCurrentTime()
    }, 1000)
    this.loadUserInfo()
    this.fetchUserBalance()
    this.fetchPendingCards()
  },
  beforeDestroy() {
    if (this.autoPlayTimer) clearInterval(this.autoPlayTimer)
    if (this.loginTimeoutTimer) clearInterval(this.loginTimeoutTimer)
  },
  methods: {
    updateCurrentTime () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    checkLoginTimeout () {
      const loginTime = localStorage.getItem('loginTime')
      if (!loginTime) {
        this.logout()
        return
      }
      const now = Date.now()
      const loginTimestamp = parseInt(loginTime)
      const twoHours = 2 * 60 * 60 * 1000
      if (now - loginTimestamp > twoHours) {
        this.logout()
      }
    },
    logout () {
      localStorage.removeItem('userAccNo')
      localStorage.removeItem('userName')
      localStorage.removeItem('userPhone')
      localStorage.removeItem('loginTime')
      this.$router.push('/')
    },
    confirmLogout () {
      this.showLogoutModal = false
      this.logout()
    },
    loadUserInfo () {
      this.userInfo.name = localStorage.getItem('userName') || '用户'
      this.userInfo.phone = localStorage.getItem('userPhone') || ''
    },
    async fetchUserBalance () {
      try {
        const userAccNo = localStorage.getItem('userAccNo') || 'zjz001'
        const response = await fetch('https://api.goquanyi.com/bwqy/web/apiOpen/v1/phoneGoquanyi', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({userPhone: userAccNo})
        })
        const data = await response.json()
        console.log('用户订购信息：', data)
        if (data.result.code === 'ok') {
          this.thisljlqShow = false
          const result = data.result
          console.log('用户订购信息', result)
          const state = Number(result.state); // 确保为数字
          const stateMap = {2: '正常', 3: '已退订'};
          this.userInfo.state = stateMap[state] || '异常';
          this.userInfo.balance = result.startTime || 0
          this.userInfo.frozenAmount = result.endTime || 0
          this.userInfo.deposit = parseFloat(result.hxyajje) || 0
        } else {
          this.thisljlqShow = true
          this.userInfo.frozenAmount = '暂未获取订购权益包信息，如已订购请过10分钟后再试！'
          console.error('获取用户余额信息失败:', data.result.msg)
        }
      } catch (error) {
        console.error('获取用户余额信息失败:', error)
      }
    },
    nextNotice () {
      this.currentNoticeIndex = (this.currentNoticeIndex + 1) % this.notices.length
    },
    goToNotice (index) {
      this.currentNoticeIndex = index
    },
    startAutoPlay () {
      this.autoPlayTimer = setInterval(() => {
        this.nextNotice()
      }, 3000)
    },
    formatDateTime (date) {
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },
    claimCard (card) {
      if (this.thisljlqShow || this.isClaiming) return
      this.currentCard = card
      this.showClaimModal = true
    },
    async confirmClaim () {
      if (!this.currentCard || this.isClaiming) return
      this.isClaiming = true
      try {
        const userAccNo = localStorage.getItem('userAccNo') || 'zjz001'
        const proNo = this.currentCard.proNo
        if (!proNo) throw new Error('缺少权益编号，无法领取')
        const response = await fetch('https://api.goquanyi.com/bwqy/web/apiOpen/v1/gotoQuanyi', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({userPhone: userAccNo, proNo})
        })
        const data = await response.json()
        console.log('领取返回:', data)
        if (data.result.code === '000') {
          alert(data.result.msg || '领取成功！')
          this.showClaimModal = false
          this.showClaimResultModal = true
          const index = this.cards.pending.findIndex(c => c.id === this.currentCard.id)
          if (index !== -1) this.cards.pending.splice(index, 1)
        } else {
          alert(data.result.msg || '领取失败，请稍后重试')
        }
      } catch (error) {
        console.error('领取请求失败:', error)
        alert('网络异常，请稍后重试')
      } finally {
        this.isClaiming = false
      }
    },
    closeClaimResultModal () {
      this.showClaimResultModal = false
      this.currentCard = null
    },
    async showDetailModalHandler () {
      this.showDetailModal = true
      this.claimRecordsLoading = true
      try {
        const userAccNo = localStorage.getItem('userAccNo') || 'zjz001'
        const response = await fetch('https://api.goquanyi.com/bwqy/web/apiOpen/v1/showQuanyiLingquList', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({userPhone: userAccNo})
        })
        const data = await response.json()
        console.log('领取记录返回:', data)
        if (data.result && data.result.code === 'ok') {
          const list = data.result.proLs || []
          const lqstateMap = {0: '处理中', 1: '发放成功', 2: '发放失败'}
          this.claimRecords = list.map(item => ({
            time: item.createTime || '',
            proName: item.proName || '未知权益',
            lqState: lqstateMap[item.lqState] || '异常'
          }))
        } else {
          this.claimRecords = []
        }
      } catch (error) {
        console.error('获取领取记录失败:', error)
        this.claimRecords = []
      } finally {
        this.claimRecordsLoading = false
      }
    },
    processCard (card) {
      this.currentProcessCard = card
      this.showProcessModal = true
    },
    processSuccess () {
      if (!this.currentProcessCard || this.isProcessing) return
      this.isProcessing = true
      const index = this.cards.claimed.findIndex(c => c.id === this.currentProcessCard.id)
      if (index !== -1) {
        const processedCard = {...this.cards.claimed[index]}
        processedCard.processedAt = this.formatDateTime(new Date())
        processedCard.status = '成功'
        this.cards.processed.push(processedCard)
        this.cards.claimed.splice(index, 1)
      }
      this.processResult = 'success'
      this.showProcessModal = false
      this.showResultModal = true
      this.isProcessing = false
    },
    processFail () {
      if (!this.currentProcessCard || this.isProcessing) return
      this.isProcessing = true
      const index = this.cards.claimed.findIndex(c => c.id === this.currentProcessCard.id)
      if (index !== -1) {
        const processedCard = {...this.cards.claimed[index]}
        processedCard.processedAt = this.formatDateTime(new Date())
        processedCard.status = '失败'
        this.cards.processed.push(processedCard)
        this.cards.claimed.splice(index, 1)
      }
      this.processResult = 'fail'
      this.isProcessing = false
      this.showProcessModal = false
      this.showResultModal = true
    },
    closeResultModal () {
      this.showResultModal = false
      this.processResult = null
      this.currentProcessCard = null
    },
    async fetchPendingCards () {
      try {
        const userAccNo = localStorage.getItem('userAccNo') || 'zjz001'
        const response = await fetch('https://api.goquanyi.com/bwqy/web/apiOpen/v1/getQuanyiList', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({userPhone: userAccNo})
        })
        const data = await response.json()
        console.log('待领取卡片列表', data)
        this.thisljlqShow = !(data.result.type === 'ok')
        const dlqList = data.result.proLs || []
        this.cards.pending = dlqList.map((card, index) => ({
          id: index + 1,
          name: card.proVname || '未知权益',
          proTsy: card.proTsy,
          proSm: card.proSm,
          quantity: card.quantity || 1,
          cardLogo: card.proImgo || '',
          proNo: card.proNo
        }))
      } catch (error) {
        alert('获取待领取卡片列表失败，请重试')
      }
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.person-container {
  background: #f5f7fa;
  padding: 0 12px;
  max-width: 100%;
  overflow-x: hidden;
}

.user-card {
  height: 108px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 16px 20px;
  display: flex;
  align-items: baseline;
  gap: 16px;
  margin: 10px 0 20px 0;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
  position: relative;
  width: 100%;
}

.avatar {
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
}

.avatar-icon {
  font-size: 20px;
  margin-bottom: 2px;
}

.avatar-text {
  font-size: 11px;
  font-weight: 500;
}

.user-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.username {
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  flex-shrink: 0;
}

/* ========== 修复：user-details 在一行显示，字体调小 ========== */
.user-details {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 10px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.5;
  flex-shrink: 0;
}

.detail-item {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.92);
  white-space: nowrap;
  letter-spacing: 0.3px;
}

/* ========== 修复结束 ========== */
.balance-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  height: 56px;
  flex-shrink: 0;
}

.detail-btn {
  padding: 6px 16px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.detail-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.notice-section {
  background: linear-gradient(135deg, #fff5f5 0%, #fff0f0 100%);
  border: 1px solid #ffe0e0;
  border-radius: 12px;
  padding: 15px 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.notice-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.notice-content {
  flex: 1;
  overflow: hidden;
  height: 24px;
  position: relative;
}

.notice-track {
  display: flex;
  transition: transform 0.3s ease;
}

.notice-item {
  white-space: nowrap;
  flex-shrink: 0;
  width: 100%;
  font-size: 14px;
  color: #d93026;
  text-align: left;
}

.notice-dots {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(217, 48, 38, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot.active {
  background: #d93026;
  width: 20px;
  border-radius: 4px;
}

.task-section {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  width: 100%;
  overflow-x: hidden;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.tab-container {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.tab-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px;
  background: #f5f5f5;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-btn.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}

.tab-count {
  padding: 2px 8px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-size: 12px;
}

.tab-btn.active .tab-count {
  background: rgba(255, 255, 255, 0.2);
}

.pending-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  width: 100%;
}

.pending-card {
  background: #fff;
  border: 1px solid #ffe0e0;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  word-break: break-word;
}

.card-info {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.card-logo {
  width: 45px;
  height: 45px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8), 0 0 0 3px rgba(102, 126, 234, 0.3), 0 0 15px rgba(102, 126, 234, 0.4), 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-icon {
  width: 45px;
  height: 45px;
  border-radius: 8px;
  background: linear-gradient(145deg, #fff, #f0f0f0);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8), 0 0 0 3px rgba(102, 126, 234, 0.3), 0 0 15px rgba(102, 126, 234, 0.4), 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-details {
  flex: 1;
  min-width: 0;
}

.card-name {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-value {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  word-break: break-word;
  line-height: 1.3;
}

.claim-btn {
  padding: 8px 12px;
  background: linear-gradient(135deg, #dccf60 0%, #60bfe1 100%);
  color: #fff;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.claim-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.claim-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

/* 小屏幕下依然保持两列，仅适当缩小间距和字体 */
@media (max-width: 480px) {
  .pending-cards {
    gap: 10px;
  }

  .pending-card {
    padding: 8px;
  }

  .card-name {
    font-size: 13px;
  }

  .card-value {
    font-size: 11px;
  }

  .claim-btn {
    font-size: 12px;
    padding: 6px 8px;
  }

  .card-logo, .card-icon {
    width: 38px;
    height: 38px;
    font-size: 18px;
  }

  /* 小屏手机进一步微调 user-details */
  .user-details {
    gap: 1px 6px;
    font-size: 10px;
  }

  .detail-item {
    font-size: 10px;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 500px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: #f5f5f5;
  border-radius: 50%;
  font-size: 16px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  background: #eee;
  color: #666;
}

.modal-body {
  padding: 20px 24px;
  max-height: 400px;
  overflow-y: auto;
}

.transaction-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.transaction-table th {
  text-align: center;
  padding: 12px 16px;
  font-size: 14px;
  color: #999;
  font-weight: 500;
  border-bottom: 1px solid #f0f0f0;
}

.transaction-table th:nth-child(1) {
  width: 45%;
}

.transaction-table th:nth-child(2) {
  width: 40%;
}

.transaction-table th:nth-child(3) {
  width: 15%;
  text-align: center;
}

.transaction-table td {
  padding: 15px 0;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #f5f5f5;
  text-align: center;
}

.transaction-table td:first-child {
  text-align: left;
}

.status-success {
  color: #52c41a;
  font-weight: 500;
}

.loading-tip, .empty-state {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 14px;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
}

.confirm-btn, .cancel-btn {
  padding: 10px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 10px;
}

.claim-info, .process-info {
  padding: 10px 0;
}

.claim-item, .process-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
}

.claim-item:last-child, .process-item:last-child {
  border-bottom: none;
}

.claim-label, .process-label {
  width: 80px;
  font-size: 14px;
  color: #999;
  flex-shrink: 0;
}

.claim-value, .process-value {
  font-size: 14px;
  color: #333;
}

.claim-value.highlight, .process-value.highlight {
  color: #667eea;
  font-weight: 600;
}

.process-success-btn, .process-fail-btn {
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-left: 10px;
}

.process-success-btn {
  background: linear-gradient(135deg, #20c997 0%, #17a2b8 100%);
  color: #fff;
}

.process-fail-btn {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  color: #fff;
}

.confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.current-time {
  position: absolute;
  bottom: 10px;
  color: #fff;
}
.transaction-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
.transaction-table th,
.transaction-table td {
  padding: 12px 8px;
  font-size: 13px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  white-space: normal;      /* 允许换行 */
  word-break: break-word;   /* 长单词/数字换行 */
  vertical-align: middle;
}
/* 列宽分配（顺序：时间、权益名称、状态） */
.transaction-table th:nth-child(1),
.transaction-table td:nth-child(1) {
  width: 30%;
}
.transaction-table th:nth-child(2),
.transaction-table td:nth-child(2) {
  width: 50%;
}
.transaction-table th:nth-child(3),
.transaction-table td:nth-child(3) {
  width: 20%;
  text-align: center;
  white-space: nowrap;      /* 状态内容短，不换行 */
}

@media (max-width: 768px) {
  .user-card {
    text-align: center;
  }

  .balance-section {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/person/person.vue